import React from "react";

const ClientKeywords = ({ handleBackBtn, keywords }) => {
  return (
    <div className="gog-client-keywords">
      <div className="gog-inner-section-header">
        <span>Keywords</span>
        <h3>Business Keywords</h3>
        <p>These keywords help customers find this merchant in search.</p>
      </div>

      {keywords && keywords.length > 0 ? (
        <div className="gog-keyword-chip-list">
          {keywords.map((key, index) => (
            <span key={`${key}-${index}`} className="gog-keyword-chip">
              {key}
            </span>
          ))}
        </div>
      ) : (
        <div className="gog-empty-state">
          No keywords are available for this merchant.
        </div>
      )}

      <div className="gog-inner-action-row">
        <button type="button" onClick={handleBackBtn} className="gog-light-btn">
          Back
        </button>
      </div>
    </div>
  );
};

export default ClientKeywords;